import {jsonRoute} from '@github-ui/react-core/json-route'
import {registerDataRouterApp, registerNavigatorApp} from '@github-ui/react-core/register-app'

import {App} from './App'
import {commitsAppBuilder} from './config/app-builder'
import {CommitEntrypoint, CommitFragmentEntrypointFuture} from './routes/Commit'
import {commitFragmentRoute} from './routes/commit-fragment-route'
import {CommitsEntrypoint} from './routes/Commits'
import {createCommitsRoutes} from './routes/create-commits-routes'
import {commitsRouteComponents} from './routes/route-components'

registerNavigatorApp('commits', () => ({
  App,
  routes: [
    jsonRoute({path: '/:owner/:repo/commits', Component: CommitsEntrypoint}),
    jsonRoute({path: '/:owner/:repo/commits/:ref', Component: CommitsEntrypoint}),
    jsonRoute({path: '/:owner/:repo/commits/:ref/:path/*', Component: CommitsEntrypoint}),
    jsonRoute({path: '/:owner/:repo/commit/:oid', Component: CommitEntrypoint}),
    jsonRoute({path: '/:owner/:repo/commit/:oid/:path/*', Component: CommitEntrypoint}),
    jsonRoute({
      path: '/_view_fragments/Voltron::CommitFragmentsController/show/:owner/:repo/:name/repo_layout',
      Component: CommitEntrypoint,
    }),
  ],
}))

export const commitsApp = commitsAppBuilder.createDataRouterAppFromRoutes([
  ...createCommitsRoutes(commitsAppBuilder, commitsRouteComponents),
  // Served under `/_view_fragments`, so it cannot nest under the repo-scoped layout. The backend
  // sends the canonical commit path as the initial path, so this only matches legacy renders.
  commitFragmentRoute.toRoute({Component: CommitFragmentEntrypointFuture}),
])
registerDataRouterApp(commitsApp)
